import { getTemplate } from "../handlebars";
import { debounce } from "../lib";
import $ from 'jquery';
import Handlebars from "handlebars";

export default class DatasetListPage {
    requestDatasets() {
        const url = pageData.apiURL;
        const params = new URLSearchParams({
            search: pageData.state.searchValue,
            products: [pageData.productSlug],
            page_size: 12,
            page: pageData.state.pageNumber || 1,
            roles: pageData.state.roleFilter,
        }).toString();
        $.ajax({
            url: `${url}?${params}`,
            type: "GET",
            success: function (data) {
                this.getPageControls(data);
                this.loadDatasets(data);
                this.getDatasetNumbers(data);
                this.requestProductTabs(params)
                history.replaceState({}, "", `?${params}`);
            }.bind(this),
        });
    }

    getPageControls(data) {
        $(".page-number").remove();
        const pageLink = $(".page-link");
        const numPages = Math.ceil(data.count / data.page_size);
        const previousPage = $("#previous-page");
        const nextPage = $("#next-page");
        const currentPage = parseInt(data.page);

        if (numPages <= 1) {
            pageLink.hide();
            return;
        }
        pageLink.show();

        if (currentPage === 1) {
            previousPage.addClass("disabled").parent().addClass("disabled");
        } else {
            previousPage
                .removeClass("disabled")
                .parent()
                .removeClass("disabled");
            previousPage.data("page_num", currentPage - 1);
        }

        if (currentPage === numPages) {
            nextPage.addClass("disabled").parent().addClass("disabled");
        } else {
            nextPage.removeClass("disabled").parent().removeClass("disabled");
            nextPage.data("page_num", currentPage + 1);
        }

        let pageItems = document.getElementById("page-items");

        for (let i = 1; i <= numPages; i++) {
            let item = document.createElement("li");
            item.classList.add("page-item");

            if (i === parseInt(data.page)) {
                item.classList.add("active");
            }
            let pageLink = document.createElement("a");
            pageLink.classList.add("page-link", "page-number");
            pageLink.text = i.toString();
            pageLink.href = "#";
            pageLink.dataset.page_num = i.toString();
            item.appendChild(pageLink);
            pageItems.insertBefore(
                item,
                document.getElementById("next-page-li")
            );
        }
    }

    getDatasetNumbers(data) {
        const currentPage = parseInt(data.page);
        const pageSize = parseInt(data.page_size);
        $(".dataset-count").text(data.count);
        const startNum = Math.min(
            data.count,
            (currentPage - 1) * pageSize + 1
        );
        const endNum = Math.min(data.count, startNum + pageSize - 1);
        $("#start-num").text(startNum);
        $("#end-num").text(endNum);
    }

    loadDatasets(data) {
        $("#dataset-cards").empty();
        if (data.count === 0) {
            $("#no-datasets").show();
        } else {
            $("#no-datasets").hide();
        }

        data.results.forEach(function (dataset) {
            const name = dataset.name;
            const tags_with_weights = dataset.tags;
            const browse_url = dataset.browse_url;
            const admin_url = dataset.admin_url || "";
            let thumbnail_url = dataset.thumbnail;

            if (!thumbnail_url) {
                thumbnail_url = pageData.imageUrl;
            }
            let description = dataset.description;
            if (description.length === 0) {
                description = "";
            }
            let owner = dataset.owner || "--";
            let updateDate = dataset.latest_workflow.date || "--";

            let card = document.createElement("div");
            card.className = "col-sm-6 col-md-4 col-lg-4 py-3";

            card.innerHTML = Handlebars.partials.datasetCard({
                browse_url: browse_url,
                name: name,
                thumbnail_url: thumbnail_url,
                description: description,
                tags_with_weights: tags_with_weights,
                admin_url: admin_url,
                owner: owner,
                updateDate: updateDate,
            });
            document.getElementById("dataset-cards").appendChild(card);
        });
    }
    /**
     * Sends a GET request to the server to retrieve the serialised data for all product groups.
     * It then calls buildProductTabs.
     */
    requestProductTabs(params='', url = `${pageData.productListURL}?${params}`, allProducts = [], allCount = null) {
        $.ajax({
            url: `${url}`,
            type: "GET",
            success: function (data) {
                allProducts.push(...(data.results || []));
                const totalCount = allCount === null ? data.all_count : allCount;

                if (data.next) {
                    this.requestProductTabs(params, data.next, allProducts, totalCount);
                    return;
                }

                this.buildProductTabs({ ...data, all_count: totalCount, results: allProducts });
            }.bind(this),
        });
    }

    /**
     * Builds the tabs for filtering datasets by product group. It creates a tab for each group and adds it to the page.
     * If a product group slug is present in the page URL, the corresponding tab is set to 'active'.
     * If there is no slug, the 'all' tab is set to 'active'.
     */
    buildProductTabs(data) {
        const tabs = []
        const allTab = document.createElement("div");
        const active = !pageData.productSlug ? "active": "";
        allTab.innerHTML = Handlebars.partials.productGroupTab({
            name: 'All',
            active: active,
            count: data.all_count
        });
        tabs.push(allTab)
        data.results.forEach(product => {
            if (!product.has_access) {
                return
            }
            // Add a tab
            const tab = document.createElement("div");
            const active = product.slug === pageData.productSlug ? "active" : "";
            tab.innerHTML = Handlebars.partials.productGroupTab({
                name: product.name,
                active: active,
                slug: product.slug,
                count: product.dataset_count
            });
            tabs.push(tab)
        });
        $("#product-group-tabs").html(tabs);
    }

    /**
     * Updates the page when a product tab is clicked on.
     * It removes the active class from the current tab and adds it to the clicked tab.
     * It updates the product slug and sets the page number to 1, then requests the datasets.
     */
    listenForProductTabClick() {
        $(document).on(
            "click",
            ".product-tab",
            function (e) {
                e.preventDefault();
                $('[data-product-slug="'+pageData.productSlug+'"]').removeClass('active');
                $(e.target).addClass("active");
                pageData.productSlug =  $(e.target).data("product-slug");
                pageData.state.pageNumber = 1;
                this.requestDatasets();
            }.bind(this)
        );
    }

    /**
     * Appends the dataset count badge to the active tab.
     * @param {int} count - The count of datasets.
     */
    getCountBadge(count) {
        $(".product-tab.active").append(`<span class='position-absolute top-0 start-100 translate-middle count-badge
            badge rounded-pill bg-success'>${count}</span>`);
    }

    ready() {
        for (const [key, value] of Object.entries(pageData.partials)) {
            getTemplate(value, key);
        }
        this.requestProductTabs();
        this.requestDatasets();
        $(document).on(
            "click",
            ".page-link",
            function (e) {
                e.preventDefault();
                const pageNumber = $(e.target).data("page_num");
                if (pageNumber) {
                    pageData.state.pageNumber = pageNumber;
                    this.requestDatasets();
                }
            }.bind(this)
        );
        this.listenForProductTabClick();

        let timeoutId;

        $(document).on(
            "input",
            "#search-dataset",
            function (e) {
                e.preventDefault();
                pageData.state.pageNumber = 1;
                pageData.state.searchValue =
                    document.getElementById("search-dataset").value;
                if (timeoutId) {
                    clearTimeout(timeoutId);
                }
                // Set a new timeout
                timeoutId = setTimeout(
                    debounce(this.requestDatasets, 500).bind(this),
                    500
                );
            }.bind(this)
        );

        $("input.role-select").change(
            function (e) {
                let roles = [];
                $("input.role-select:checked").each(function () {
                    roles.push($(e.target).attr("name"));
                });
                pageData.state.pageNumber = 1;
                pageData.state.roleFilter = roles;
                this.requestDatasets();
            }.bind(this)
        );
    }
}
